import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel,
    CircularProgress,
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { ClothIssueTitle } from '../TitleList';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectBalelist, selectChallanNo, selectCloths, selectEmployees, selectFirm, selectItems, selectSOlistReg, selectsono } from '../Selectors/Master/ItemSelectors';
import { fetchEmployeeData } from '../../Store/PHPSlice/Employee';
import { fetchSORegister } from '../../Store/PHPSlice/Sale/SaleOrder';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { clothIssueEntry, fetchChallanNo, fetchClothStkBale } from '../../Store/PHPSlice/Cutting/clothIssue';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { errorStyles } from '../../Utils/table';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import Dropdown from '../FieldsComponents/Dropdown';
import PreviewIcon from '@mui/icons-material/Preview';
import axios from 'axios';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';



const ClothIssueEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        ordType: '0',
        firm: '',
        challanNo: '',
        sono: '0',
        category: '',
        master: '',
        item: '',
        cloth: '',
        bale: '',
        totMtr: '',
        item_totmtr: '',
        cltsts: '0',
        userId: userdata?.ID
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        master: fetchEmployeeData,
        sono: fetchSORegister,
        firm: fetchCompanyData,
        depart: fetchDepartmentData,
        item: fetchItemData
        // Add more mappings if needed
    };
    const [masterlist, setMasterlist] = useState([]);
    const [bale, setBale] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [itemsData, setItemsData] = useState([]);
    const [localClothList, setLocalClothList] = useState([]);
    const [localItems, setLocalItems] = useState([]);
    const [soFirm, setSoFirm] = useState([]);
    const [soCloth, setSoCloth] = useState([]);
    const [clothids, setClothids] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectSonoData, setSelectSonoData] = useState([]);
    const [selectSoItems, setSelectSoItems] = useState([]);
    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const emplist = useSelector(selectEmployees);
    const solist = useSelector(selectSOlistReg);
    const clothlist = useSelector(selectCloths);
    const itemlist = useSelector(selectItems);
    const challanNo = useSelector(selectChallanNo);
    const firmlist = useSelector(selectFirm);
    const balelist = useSelector(selectBalelist);
    const department = useSelector(selectDaparement);

    useEffect(() => {
        dispatch(fetchChallanNo());
        dispatch(fetchSORegister());
        dispatch(fetchClothData());
        dispatch(fetchEmployeeData());
        dispatch(fetchClothStkBale());
        dispatch(fetchCompanyData());
        dispatch(fetchItemData());
        dispatch(fetchDepartmentData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    // console.log(balelist);

    const baseUrl = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        if (challanNo?.data) {
            const no = challanNo?.data?.challan;
            setFormData(prev => ({
                ...prev,
                challanNo: no
            }));
        }
    }, [challanNo]);

    useEffect(() => {
        if (balelist?.manualCloths?.length > 0) {
            setLocalClothList(balelist?.manualCloths); // Initialize localClothList with data from Redux store
        }
    }, [balelist]);

    useEffect(() => {
        if (itemlist?.data?.length > 0) {
            const list = itemlist?.data;
            setLocalItems(list);
        }
    }, [itemlist]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        switch (dropdownType) {
            case 'category':
                // if (value === '1') {
                //     const filterMaster = emplist.data.length > 0 ? emplist.data.filter((val) => val.departNm === 'CUTTING') : '';
                //     if (filterMaster.length > 0) {
                //         setMasterlist(filterMaster);
                //     } else {
                //         setMasterlist([]);
                //     }
                // }
                // if (value === '2') {
                //     const filterMaster = emplist.data.length > 0 ? emplist.data.filter((val) => val.departNm === 'CUT-TO-PACK') : '';
                //     if (filterMaster.length > 0) {
                //         setMasterlist(filterMaster);
                //         console.log(filterMaster);
                //     } else {
                //         setMasterlist([]);
                //     }

                //     // fetchEmployeeCategory();
                // }

                break;
            case 'depart':
                if (value && formData.category !== " ") {
                    const data = {
                        category: formData.category,
                        depart: value
                    };
                    fetchEmployeeCategory(data);
                } else {
                    setMasterlist([]);
                }
                break;
            case 'cloth':
                if (value) {
                    // Filter bales for the selected cloth, excluding bales already in use
                    // const availableBales = balelist.data.filter((val) =>
                    //     val.clothId === value && !tableData.some(item => item.baleId === val.ID)
                    // );
                    // setBale(availableBales);

                    const availableBales = [];

                    // First filter and process bales based on the specific clothId (value)
                    const specificClothBales = balelist?.data?.filter((val) => {
                        if (val.clothId === value) {
                            // Check if the baleId exists in itemsData.cloths and perform calculations
                            const itemInItemsData = itemsData?.some(item =>
                                item.cloths.some(cloth => cloth.baleId === val.ID)
                            );

                            if (itemInItemsData) {
                                // Find the specific cloth data
                                const clothData = itemsData?.find(item =>
                                    item.cloths.some(cloth => cloth.baleId === val.ID)
                                );

                                if (clothData) {
                                    const cloth = clothData?.cloths?.find(c => c.baleId === val.ID);

                                    if (cloth) {
                                        // If givenmtr is not equal to balemtr, calculate the remaining meters
                                        if (cloth.givenmtr !== cloth.balemtr) {
                                            const remainingMtr = cloth.balemtr - cloth.givenmtr;
                                            val.remainingMtr = remainingMtr; // Add remaining meters to the bale
                                        } else {
                                            // If givenmtr === balemtr, exclude this bale
                                            return false;
                                        }
                                    }
                                }
                            }
                            return true; // Include this bale in the list
                        }
                        return false; // Not a matching clothId, exclude it
                    });

                    // Add the processed bales to the availableBales list
                    availableBales.push(...specificClothBales);

                    // Finally, update the state with the filtered bales
                    setBale(availableBales);
                }
                break;
            case 'sono':
                if (value) {

                    fetchSonowisedata(value);
                    // const selectSo = solist.data.length > 0 ? solist.data.find(val => val.ID === value) : '';
                    // // console.log(selectSo);
                    // if (selectSo) {
                    //     const firmList = firmlist.data.length > 0 ? firmlist.data.filter(val => val.ID === selectSo.firmId) : [];
                    //     if (firmList.length === 1) {
                    //         setSoFirm(firmList[0]); // Automatically set the firm if there's only one
                    //         setFormData(prevFormData => ({
                    //             ...prevFormData,
                    //             firm: firmList[0].ID // Update formData to reflect the selected firm
                    //         }));
                    //     } else {
                    //         setSoFirm(null); // Allow user to select from the full list if multiple firms
                    //         setFormData(prevFormData => ({
                    //             ...prevFormData,
                    //             firm: ''
                    //         }));
                    //     }

                    //     // const validClothIds = [selectSo.mainClothId, selectSo.m1Id, selectSo.m2Id, selectSo.m3Id].filter(id => id !== '0');
                    //     // setClothids(validClothIds);
                    //     // if (validClothIds.length > 0) {
                    //     //     const soClothlist = clothlist.data.length > 0 ? clothlist.data.filter(val => validClothIds.includes(val.ID)) : [];
                    //     //     setSoCloth(soClothlist);
                    //     // }

                    // }
                }
                break;
            case 'item':
                if (formData.ordType === '1' && value) {
                    const selectSONOCloths = selectSonoData?.find((val) => val.itemId === value);
                    const clothlist = [
                        {
                            ID: selectSONOCloths?.mainClothId,
                            clothNm: selectSONOCloths?.mainClothId !== '0' ? selectSONOCloths.mclothNm : null
                        },
                        {
                            ID: selectSONOCloths?.m1Id,
                            clothNm: selectSONOCloths?.m1Id !== '0' ? selectSONOCloths.m1clothNm : null
                        },
                        {
                            ID: selectSONOCloths?.m2Id,
                            clothNm: selectSONOCloths?.m2Id !== '0' ? selectSONOCloths.m2clothNm : null
                        },
                        {
                            ID: selectSONOCloths?.m3Id,
                            clothNm: selectSONOCloths?.m3Id !== '0' ? selectSONOCloths.m3clothNm : null
                        }
                    ].filter(cloth => cloth.ID !== '0'); // Filter out objects where ID is '0'
                    setSoCloth(clothlist);
                }
                break;
            default:
                break;
        }
    };
    // console.log(selectSonoData);
    const fetchSonowisedata = async (sono) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getsonowisedata&sono=${sono}`);
            setSelectSonoData(response.data.data);
            const selectFirm = response.data?.data[0]?.firmId;
            const firmlist2 = firmlist?.data?.filter(item => item.ID === selectFirm);
            setSoFirm(firmlist2);
            const select_Items = response.data?.data?.map((val) => {
                const listItems = {
                    ID: val.itemId,
                    itemNm: val.itemNm
                };
                return listItems;
            });
            setSelectSoItems(select_Items);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchEmployeeCategory = async (ids) => {
        const { category, depart } = ids;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getEmployeeCategoryWise&category=${category}&depart=${depart}`);
            // console.log(response.data)
            setMasterlist(response?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

    };

    const handleGivenMtrChange = (index, value) => {
        // Ensure the value is a number. If not, default to 0.
        const numericValue = Number(value);

        // If the value is not a valid number, stop further execution
        if (isNaN(numericValue)) {
            return;
        }

        const updatedTableData = tableData.map((item, i) => {
            if (i === index) {
                // Ensure that givenMtr does not exceed baleMtr
                const newGivenMtr = Math.min(numericValue, item.baleMtr);
                return { ...item, givenMtr: newGivenMtr };
            }
            return item;
        });

        // Update table data
        setTableData(updatedTableData);

        // Calculate the sum of all givenMtr values
        const totalGivenMtr = updatedTableData.reduce((total, item) => {
            return total + (Number(item.givenMtr) || 0);
        }, 0);

        const prevtotalmtr = itemsData.length > 0 ? itemsData?.reduce((acc, mtr) => acc + parseInt(mtr.totmtr, 10), 0) : 0;
        const final_totmtr = totalGivenMtr + prevtotalmtr;

        // Update formData with the new total
        setFormData(prevFormData => ({
            ...prevFormData,
            totMtr: final_totmtr
        }));
    };

    const calculateBalanceMtr = (stockMtr, givenMtr) => {
        const stock = parseFloat(stockMtr);
        const given = parseFloat(givenMtr);
        if (!isNaN(stock) && !isNaN(given)) {
            return (stock - given).toFixed(2);
        }
        return stockMtr;
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const Categorylist = [
        { label: 'In-House', value: '1' },
        { label: 'Contractor', value: '2' }
    ];

    // Manual wise
    const handleAddClick = () => {
        if (bale.length > 0 && formData.bale !== '') {
            const selectbale = bale.find((val) => val.ID === formData.bale);
            const clothinfo = localClothList.find((val) => val.ID === selectbale.clothId);
            if (clothinfo) {
                var table = {
                    baleId: selectbale.ID,
                    baleNo: selectbale.bale,
                    baleMtr: selectbale.bmtr,
                    givenMtr: selectbale.bmtr,
                    clothId: selectbale.clothId,
                    clothNm: clothinfo.clothNm
                }
            }

            const updatedTableData = [...tableData, table];
            setTableData(updatedTableData);

            const totalGivenMtr = updatedTableData.reduce((total, item) => {
                return total + (Number(item.givenMtr) || 0);
            }, 0);



            // Restore the bale meters after selecting and updating givenmtr
            const updatedBales = bale.map(bale => {
                // Check if the bale's givenmtr has been updated and whether givenmtr === balemtr
                const clothData = itemsData.find(item =>
                    item.cloths.some(cloth => cloth.baleId === bale.ID)
                );

                if (clothData) {
                    const cloth = clothData.cloths.find(c => c.baleId === bale.ID);

                    if (cloth) {
                        // If the givenmtr equals balemtr, remove the bale from the list
                        if (cloth.givenmtr === cloth.balemtr) {
                            return null; // Exclude this bale
                        } else {
                            // If givenmtr is less than balemtr, restore remaining meters
                            bale.remainingMtr = cloth.balemtr - cloth.givenmtr;
                        }
                    }
                }

                return bale; // Keep the bale if it's still valid
            }).filter(bale => bale !== null); // Remove any null (excluded bales)

            const updatedClothList = updatedBales.some((val) => val.clothId === selectbale.clothId)
                ? localClothList
                : localClothList.filter((val) => val.ID !== selectbale.clothId);


            const filteredClothList = updatedClothList.filter(cloth =>
                !tableData.some(item => item.clothId === cloth.ID)
            );
            // Update the state with the filtered and updated bales
            setBale(updatedBales);

            // setLocalClothList(filteredClothList);
            let prevTotalGmtr = 0;
            if (itemsData.length > 0) {
                const prevmtr = itemsData?.reduce((acc, mtr) => acc + parseInt(mtr.totmtr, 10), 0);
                prevTotalGmtr = prevmtr + totalGivenMtr;
            } else {
                prevTotalGmtr = totalGivenMtr
            }

            setFormData(prev => ({
                ...prev,
                bale: '',
                cloth: '',
                totMtr: prevTotalGmtr
            }));
            // console.log(totalGivenMtr)
        } else {
            alert('select the Bale No')
        }
    };

    const handleRemoveRows = () => {
        const rowsToRemove = selectedRows.map(index => tableData[index]);
        const updatedTableData = tableData.filter((_, index) => !selectedRows.includes(index));

        // Add removed rows back to bale and cloth dropdowns
        const updatedBaleList = [...bale, ...rowsToRemove.map(row => ({
            ID: row.baleId,
            bale: row.baleNo,
            bmtr: row.baleMtr,
            clothId: row.clothId
        }))];

        const updatedClothList = [...localClothList, ...rowsToRemove.map(row => ({
            ID: row.clothId,
            clothNm: row.clothNm
        }))];

        setBale(updatedBaleList);
        setLocalClothList(updatedClothList);
        setTableData(updatedTableData);
        setSelectedRows([]);

        // Update the formData if needed
        const totalGivenMtr = updatedTableData.reduce((total, item) => {
            return total + (Number(item.givenMtr) || 0);
        }, 0);

        setFormData(prev => ({
            ...prev,
            totMtr: totalGivenMtr
        }));
    };
    // console.log(itemsData)

    // SO wise
    const handleAddClickSO = () => {
        if (bale.length > 0 && formData.bale !== '') {
            const selectbale = bale.find((val) => val.ID === formData.bale);

            // Only use soCloth to find clothinfo
            const clothinfo = soCloth.length > 0 ? soCloth.find((val) => val.ID === selectbale.clothId) : '';

            if (clothinfo) {
                const table = {
                    baleId: selectbale.ID,
                    baleNo: selectbale.bale,
                    baleMtr: selectbale.bmtr,
                    givenMtr: selectbale.bmtr,
                    clothId: selectbale.clothId,
                    clothNm: `${clothinfo.clothNm} ${clothinfo.model ? clothinfo.model : ''} ${clothinfo.color ? clothinfo.color : ''} ${clothinfo.shadeNo ? clothinfo.shadeNo : ''} ${clothinfo.panna_size ? clothinfo.panna_size : ''}`
                };

                const updatedTableData = [...tableData, table];
                setTableData(updatedTableData);

                const totalGivenMtr = updatedTableData.reduce((total, item) => {
                    return total + (Number(item.givenMtr) || 0);
                }, 0);

                const updateBalelist = bale.filter((val) => val.ID !== selectbale.ID);

                const filterBale = updateBalelist.filter(bale =>
                    !updatedTableData.some(item => item.baleId === bale.ID)
                );

                setBale(filterBale);

                // Only remove cloth from soCloth if there are no other bales with the same clothId
                const hasOtherBales = updateBalelist.some((val) => val.clothId === selectbale.clothId);

                const filteredClothList = hasOtherBales
                    ? soCloth
                    : soCloth.filter((val) => val.ID !== selectbale.clothId);

                setSoCloth(filteredClothList);
                // Check if all cloth IDs are present in the clothIdsArray
                const allClothIdsPresent = clothids.every(clothId =>
                    updatedTableData.some(item => item.clothId === clothId)
                );
                if (allClothIdsPresent) {
                    setFormData(prev => ({
                        ...prev,
                        bale: '',
                        cloth: '',
                        totMtr: totalGivenMtr,
                        cltsts: 1  // Set soSts to 1 if all cloth IDs are present
                    }));
                } else {
                    setFormData(prev => ({
                        ...prev,
                        bale: '',
                        cloth: '',
                        totMtr: totalGivenMtr
                    }));
                }
            } else {
                alert('Cloth information not found in soCloth');
            }

        } else {
            alert('Select the Bale No');
        }
    };

    const handleRemoveClickSO = () => {
        if (selectedRows.length > 0) {
            // Get the rows that need to be removed based on selectedRows
            const rowsToRemove = selectedRows.map(index => tableData[index]);

            // Filter the table data to remove selected rows
            const updatedTableData = tableData.filter((_, index) => !selectedRows.includes(index));

            // Update the bale list by adding the removed bales back
            const updatedBaleList = [...bale, ...rowsToRemove.map(row => ({
                ID: row.baleId,
                bale: row.baleNo,
                bmtr: row.baleMtr,
                clothId: row.clothId
            }))];

            // Update the soCloth list by adding the removed cloths back
            const updatedSoClothList = [...soCloth, ...rowsToRemove.map(row => ({
                ID: row.clothId,
                clothNm: row.clothNm // Assuming clothNm was built from multiple properties
            }))];

            // Update the state
            setBale(updatedBaleList);
            setSoCloth(updatedSoClothList);
            setTableData(updatedTableData);
            setSelectedRows([]);

            // Update the total given meters in the form data
            const totalGivenMtr = updatedTableData.reduce((total, item) => {
                return total + (Number(item.givenMtr) || 0);
            }, 0);

            setFormData(prev => ({
                ...prev,
                totMtr: totalGivenMtr
            }));
        } else {
            alert('No rows selected to remove');
        }
    };

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            setSelectedRows(tableData.map((_, index) => index));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (index, isChecked) => {
        if (isChecked) {
            setSelectedRows([...selectedRows, index]);
        } else {
            setSelectedRows(selectedRows.filter((i) => i !== index));
        }
    };

    // Item Wise
    const handleSelectItems = (isChecked) => {
        if (isChecked) {
            setSelectedItems(itemsData.map((_, index) => index));
        } else {
            setSelectedItems([]);
        }
    };

    const handleDeleteItems = () => {
        const rowsToRemove = selectedItems.map(index => itemsData[index]);
        const updatedTableData = itemsData.filter((_, index) => !selectedItems.includes(index));
        // Add removed rows back to bale and cloth dropdowns
        const updatedBaleList = [...bale, ...rowsToRemove.map(row => ({
            ID: row.baleId,
            bale: row.baleNo,
            bmtr: row.baleMtr,
            clothId: row.clothId
        }))];

        const updatedClothList = [...localClothList, ...rowsToRemove.map(row => ({
            ID: row.clothId,
            clothNm: row.clothNm
        }))];

        setBale(updatedBaleList);
        setLocalClothList(updatedClothList);
        setItemsData(updatedTableData);
        setSelectedItems([]);

        // // Update the formData if needed
        // const totalGivenMtr = updatedTableData.reduce((total, item) => {
        //     return total + (Number(item.givenMtr) || 0);
        // }, 0);

        // setFormData(prev => ({
        //     ...prev,
        //     totMtr: totalGivenMtr
        // }));
    };

    const handleSelectItemsRow = (index, isChecked) => {
        if (isChecked) {
            setSelectedItems([...selectedItems, index]);
        } else {
            setSelectedItems(selectedItems.filter((i) => i !== index));
        }
    };

    const handleAddItems = () => {
        if (formData.ordType === '1') {
            const select_item = selectSoItems?.find(val => val.ID === formData.item);
            let item_name = select_item?.itemNm;
            let tot_mtr = tableData.length > 0 ? tableData?.reduce((acc, mtr) => acc + parseInt(mtr.givenMtr), 0) : 0;

            if (item_name) {
                const item_data = {
                    itemId: formData.item,
                    itemNm: item_name,
                    cloths: tableData,
                    totmtr: tot_mtr
                };
                const update_selectSoitms = selectSoItems.filter(val => {
                    return !itemsData.some(item => item.itemId === val.ID) && val.ID !== formData.item;
                });
                setSelectSoItems(update_selectSoitms);
                setItemsData([...itemsData, item_data]);
                // const totalmtr = totmtr + parseInt(formData, 10);
                setFormData(prev => ({
                    ...prev,
                    item: ''
                }));
                setTableData([]);
            } else {
                alert('Select Item');
            }
        } else {
            const selectItem = localItems?.find((val) => val.ID === formData.item);
            let itemNm = selectItem?.itemNm;
            let totmtr = tableData.length > 0 ? tableData?.reduce((acc, mtr) => acc + parseInt(mtr.givenMtr), 0) : 0;
            if (itemNm) {
                const itemdata = {
                    itemId: formData.item,
                    itemNm: itemNm,
                    cloths: tableData,
                    totmtr: totmtr
                };
                // Remove items from localItems if their ID matches formData.item or any itemId in itemsData
                const updateLocalItems = localItems.filter(val => {
                    return !itemsData.some(item => item.itemId === val.ID) && val.ID !== formData.item;
                });
                setLocalItems(updateLocalItems);
                setItemsData([...itemsData, itemdata]);
                // const totalmtr = totmtr + parseInt(formData, 10);
                setFormData(prev => ({
                    ...prev,
                    item: ''
                }));
                setTableData([]);
            } else {
                alert('Select Item');
            }
        }

    };

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/cloth-issue-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=800,height=500,scrollbars=yes,resizable=yes');
    };



    function convertIntoOneObject(formData, itemsData) {
        const data = {
            dt: formData.dt,
            ordType: formData.ordType,
            firm: formData.firm,
            challanNo: formData.challanNo,
            sono: formData.sono,
            category: formData.category,
            master: formData.master,
            totMtr: itemsData.reduce((acc, item) => acc + parseInt(item.totmtr), 0),
            userId: formData.userId,
            cltsts: formData.cltsts,
            tableData: itemsData
        }
        return data;
    }

    const validate = () => {
        const newErrors = {};
        if (!formData.firm) newErrors.firm = 'firm is required';
        if (!formData.challanNo) newErrors.challanNo = 'challanNo is required';
        if (!formData.sono) newErrors.sono = 'Sale Order No is required';
        if (!formData.category) newErrors.category = 'category is required';
        if (!formData.master) newErrors.master = 'master is required';
        if (!formData.totMtr) newErrors.totMtr = 'totMtr is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);
        try {

            var finalObject = convertIntoOneObject(formData, itemsData);
            // console.log(finalObject);

            const result = await dispatch(clothIssueEntry(finalObject)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Cloth Issue Added");
            alert("Cloth Issue Added");
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const handleItemNew = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistfirst = [
        {
            label: 'Item',
            id: 'item',
            options: localItems,
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleItemNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('item'),
            handleDropdownClose: () => handleDropdownClose('item'),
        }
    ];

    const dropdownlistsecond = [
        {
            label: 'Item',
            id: 'item',
            options: selectSoItems,
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleItemNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('item'),
            handleDropdownClose: () => handleDropdownClose('item'),
        }
    ];




    const dropdownlistSOFirm = [
        {
            label: 'firm',
            id: 'fitm',
            options: soFirm,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const filterDepart = {
        '1': department?.data?.filter((item) => item.departNm === 'CUTTING'),
        '2': department?.data?.filter((item) => item.departNm === 'CUT-TO-PACK' || item.departNm === 'CUTTING')
    };


    const handleDepartmentNew = () => {
        window.open(`/new-department-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistDepartment = [
        {
            label: 'Department',
            id: 'depart',
            options: filterDepart[formData.category] || [],
            value: formData.depart,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'depart', value: newValue ? newValue.ID : '' } }, 'depart'),
            getOptionLabel: (option) => option.departNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleDepartmentNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('depart'),
            handleDropdownClose: () => handleDropdownClose('depart'),
        }
    ];

    const handleEmployeeNew = () => {
        window.open(`/new-employee-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };


    const dropdownlistMaster = [
        {
            label: 'Master',
            id: 'master',
            options: masterlist?.data || [],
            value: formData.master,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'master', value: newValue ? newValue.ID : '' } }, 'master'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleEmployeeNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('master'),
            handleDropdownClose: () => handleDropdownClose('master'),
        }
    ];

    const handleLumpAdd = (id) => {
        window.open(`/ClothIssueLump/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    }

    const handleResend = (resendData) => {
        // console.log("Received data from child window:", resendData);
        if (resendData) {
            const bId = resendData?.baleId;
            const totmtr = resendData?.totmtr;
            const updateTableData = [...tableData];

            const updatedData = updateTableData.map(item =>
                item.baleId === bId
                    ? { ...item, givenMtr: totmtr }
                    : item
            );
            setTableData(updatedData);
            const totalMtr = updatedData.reduce((acc, row) => acc + parseFloat(row.givenMtr), 0);
            const item_tot = itemsData.reduce((acc, item) => acc + parseFloat(item.totmtr), 0);
            const final_tot = totalMtr + item_tot;
            setFormData(prev => ({
                ...prev,
                totMtr: final_tot
            }));
        }
        // Process the data (e.g., update state)
    };


    window.handleResendFromChild3 = handleResend;
    // console.log(itemsData);
    return (
        <>
            <Titlebar data={ClothIssueTitle} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Cloth Issue</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={3.4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '20%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1} sx={{ mt: -1.5, mb: 0.5 }}>
                                        <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                            <FormLabel component="legend">Order Type:</FormLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl component="fieldset" fullWidth>
                                                <RadioGroup row name="ordType" value={formData.ordType} onChange={handleRadioChange}>
                                                    <FormControlLabel value="0" control={<Radio />} label="Manual" />
                                                    <FormControlLabel value="1" control={<Radio />} label="Sale Order" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.ordType === '1' &&
                                    (<Grid item xs={12} md={4.5}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="sono">Sale Order No:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="sono"
                                                        name="sono"
                                                        options={balelist?.SOdata}
                                                        getOptionLabel={(option) => option.sono || ''}
                                                        value={balelist?.SOdata?.find(item => item.sono === formData.sono) || null}
                                                        onChange={(event, newValue) =>
                                                            handleDropdownChange({
                                                                target: { name: 'sono', value: newValue?.sono } // Ensure consistent controlled behavior
                                                            }, 'sono')
                                                        }
                                                        onOpen={() => handleDropdownOpen('sono')}
                                                        onClose={() => handleDropdownClose('sono')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="Select an option"
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.sono === value.sono}
                                                    />
                                                    {errors.sono && <FormHelperText style={errorStyles}>{errors.sono}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>)}

                                {/* {formData.ordType === '1' &&
                                (<Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="firm">Firm:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        id="firm"
                                                        name="firm"
                                                        options={soFirm} // Filter options based on soFirm
                                                        getOptionLabel={(option) => option.firmNm || ''}
                                                        value={soFirm?.find(item => item.ID === formData.firm) || null} // Always use the value from formData or the selected firm
                                                        onChange={(event, newValue) => {
                                                            if (!soFirm) {
                                                                handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm');
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    readOnly: soFirm, // Make the input read-only if soFirm is set
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.ID === value}
                                                    />
                                                    {errors.firm && <FormHelperText style={errorStyles}>{errors.firm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    )
                                } */}

                                {formData.ordType === '1' &&
                                    (<>
                                        {
                                            dropdownlistSOFirm && dropdownlistSOFirm.map((drop) => (
                                                <Dropdown
                                                    key={drop.label}
                                                    label={drop.label}
                                                    id={drop.id}
                                                    options={drop.options}
                                                    value={drop.value}
                                                    onChange={drop.onChange}
                                                    isDesktop={isDesktop}
                                                    getOptionLabel={drop.getOptionLabel}
                                                    isOptionEqualToValue={drop.isOptionEqualToValue}
                                                    valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                                />
                                            ))
                                        }

                                    </>)
                                }
                                {formData.ordType === '0' &&
                                    (<Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="firm">Firm:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        id="firm"
                                                        name="firm"
                                                        options={firmlist.data} // Filter options based on soFirm
                                                        getOptionLabel={(option) => option.firmNm || ''}
                                                        value={firmlist.data.find(item => item.ID === formData.firm) || null} // Always use the value from formData or the selected firm
                                                        onChange={(event, newValue) => {
                                                            handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm');
                                                        }}
                                                        onOpen={() => handleDropdownOpen('firm')}
                                                        onClose={() => handleDropdownClose('firm')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                    />
                                                    {errors.firm && <FormHelperText style={errorStyles}>{errors.firm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    )}


                                {[
                                    { label: 'Challan No', name: 'challanNo' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="category">Category:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="category"
                                                    name="category"
                                                    options={Categorylist}
                                                    getOptionLabel={(option) => option.label || ''}  // Display the label of the category
                                                    value={Categorylist.find(item => item.value === formData.category) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'category', value: newValue ? newValue.value : '' } }, 'category')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    // isOptionEqualToValue={(option, value) => option && value && option.value === value}
                                                    noOptionsText="No options"

                                                />
                                                {errors.category && <FormHelperText style={errorStyles}>{errors.category}</FormHelperText>}

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {
                                    dropdownlistDepartment && dropdownlistDepartment?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {
                                    dropdownlistMaster && dropdownlistMaster?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {formData.ordType === '0' && (
                                    <>
                                        {
                                            dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                                <DropdownWithBtn
                                                    key={drop.label}
                                                    label={drop.label}
                                                    id={drop.id}
                                                    options={drop.options}
                                                    value={drop.value}
                                                    onChange={drop.onChange}
                                                    isDesktop={isDesktop}
                                                    getOptionLabel={drop.getOptionLabel}
                                                    isOptionEqualToValue={drop.isOptionEqualToValue}
                                                    valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                                    handleAddNew={drop.handleAddNew}
                                                    btnlabel={drop.btnlabel}
                                                    handleDropdownOpen={drop.handleDropdownOpen}
                                                    handleDropdownClose={drop.handleDropdownClose}
                                                />
                                            ))
                                        }
                                    </>
                                )}

                                {formData.ordType === '1' && (
                                    <>
                                        {
                                            dropdownlistsecond && dropdownlistsecond.map((drop) => (
                                                <DropdownWithBtn
                                                    key={drop.label}
                                                    label={drop.label}
                                                    id={drop.id}
                                                    options={drop.options}
                                                    value={drop.value}
                                                    onChange={drop.onChange}
                                                    isDesktop={isDesktop}
                                                    getOptionLabel={drop.getOptionLabel}
                                                    isOptionEqualToValue={drop.isOptionEqualToValue}
                                                    valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                                    handleAddNew={drop.handleAddNew}
                                                    btnlabel={drop.btnlabel}
                                                    handleDropdownOpen={drop.handleDropdownOpen}
                                                    handleDropdownClose={drop.handleDropdownClose}
                                                />
                                            ))
                                        }
                                    </>
                                )}

                                {formData.ordType === '1' && (
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="cloth">Cloth:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        id="cloth"
                                                        name="cloth"
                                                        options={soCloth.length > 0 ? soCloth : []}
                                                        getOptionLabel={(option) => option.clothNm || ''}
                                                        value={soCloth.length > 0 ? soCloth.find(item => item.ID === formData.cloth) : null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'cloth', value: newValue ? newValue.ID : '' } }, 'cloth')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        noOptionsText={soCloth.length === 0 ? "No options" : ""}
                                                        isOptionEqualToValue={(option, value) => option && value && option.ID === value.ID}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}

                                {formData.ordType === '0' && (
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="cloth">Cloth:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        id="cloth"
                                                        name="cloth"
                                                        options={localClothList}
                                                        getOptionLabel={(option) => option.clothNm}
                                                        value={localClothList.find(item => item.ID === formData.cloth) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'cloth', value: newValue ? newValue.ID : '' } }, 'cloth')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => {
                                                            return option && value && option.ID === value.ID;
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="bale">Bale No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="bale"
                                                    name="bale"
                                                    options={bale.filter(bale => !tableData.some(item => item.baleId === bale.ID))}
                                                    getOptionLabel={(option) => option.bale || ''}
                                                    value={bale.find(item => item.ID === formData.bale) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'bale', value: newValue ? newValue.ID : '' } }, 'bale')}
                                                    onOpen={() => handleDropdownOpen('bale')}
                                                    onClose={() => handleDropdownClose('bale')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {formData.ordType === '0' &&
                                    (<Grid item xs={12} md={2}>
                                        <Button variant="contained" color="primary" onClick={handleAddClick} disabled={formData.bale === ""}>Bale Add</Button>
                                    </Grid>)
                                }
                                {formData.ordType === '1' &&
                                    (<Grid item xs={12} md={2}>
                                        <Button variant="contained" color="primary" onClick={handleAddClickSO} disabled={formData.bale === ""}>Bale Add</Button>
                                    </Grid>)
                                }

                                {formData.ordType === '0' && (<Grid item xs={12} md={2}>
                                    <Button variant="contained" color="primary" onClick={handleRemoveRows} disabled={selectedRows.length === 0}>Remove</Button>
                                </Grid>)}

                                {formData.ordType === '1' && (<Grid item xs={12} md={2}>
                                    <Button variant="contained" color="primary" onClick={handleRemoveClickSO} disabled={selectedRows.length === 0}>Remove</Button>
                                </Grid>)}


                                {[

                                    { label: 'Total Given Mtr', name: 'totMtr', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <Grid item xs={10} md={11}>
                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <Checkbox
                                                                    checked={tableData.length > 0 && selectedRows.length === tableData.length}
                                                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Sr.No.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Cloth</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Bale No.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Stock Mtr.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Given Mtr.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Bal Mtr.</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {tableData.length > 0 ? (
                                                            tableData.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                        <Checkbox
                                                                            checked={selectedRows.includes(index)}
                                                                            onChange={(e) => handleSelectRow(index, e.target.checked)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.clothNm}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.baleNo}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.baleMtr}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.givenMtr}
                                                                            // onChange={(e) => handleGivenMtrChange(index, e.target.value)}
                                                                            style={{ width: '80px', padding: '1px' }}
                                                                            readOnly
                                                                        />
                                                                        <button type='button' className="add" style={{ marginLeft: '10px' }} onClick={() => handleLumpAdd(item.baleId)}>Lump</button>
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                        {calculateBalanceMtr(item.baleMtr, item.givenMtr)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : null}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <Button variant="contained" color="primary" onClick={handleAddItems}>Add</Button>
                                        </Grid>
                                    </>
                                }


                                {Array.isArray(itemsData) && itemsData.length > 0 &&
                                    <>
                                        <Grid item xs={12} md={12}>
                                            <Button variant="contained" color="primary" onClick={handleDeleteItems} disabled={selectedItems.length === 0}>Delete</Button>
                                        </Grid>

                                        <Grid item xs={10} md={11}>
                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={itemsData.length > 0 && selectedItems.length === itemsData.length}
                                                                    onChange={(e) => handleSelectItems(e.target.checked)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Mtr.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>View</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {itemsData.length > 0 ? (
                                                            itemsData.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <Checkbox
                                                                            checked={selectedItems.includes(index)}
                                                                            onChange={(e) => handleSelectItemsRow(index, e.target.checked)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.itemNm}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.totmtr}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                        <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(item)} />
                                                                    </TableCell>

                                                                </TableRow>
                                                            ))
                                                        ) : null}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>

                                    </>
                                }

                                {
                                    itemsData?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}


                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ClothIssueEntry;
